import { render, staticRenderFns } from "./orderCountChart.vue?vue&type=template&id=b83806c4&scoped=true&"
import script from "./orderCountChart.vue?vue&type=script&lang=js&"
export * from "./orderCountChart.vue?vue&type=script&lang=js&"
import style0 from "./orderCountChart.vue?vue&type=style&index=0&id=b83806c4&prod&lang=scss&scoped=true&"
import style1 from "./orderCountChart.vue?vue&type=style&index=1&id=b83806c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83806c4",
  null
  
)

export default component.exports